/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component } from '@angular/core';
import { Account } from '../../../models/account.model';
import { Error } from '../../../models/error.model';
import { ArticlesService } from '../../../services/articles.service';
import { StorageProvider } from '../../../services/storage.provider';
import { InfoPopupComponent } from '../../../shared/components/infopopup/infopopup';
import { MetaProvider } from '../../../services/meta.provider';
import { Multitenant } from '../../../services/multitenant.provider';
import { PopoverController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-createaccount1',
  templateUrl: 'createaccount1.html',
  styleUrls: ['createaccount1.scss']
})
export class CreateAccount1Page {
  public model: Account = new Account('', '', '', '', '', false, false, false);
  public error: Error = new Error();
  public userstatus: boolean;
  public validation: boolean;
  public validation2: boolean;
  public userstatus2: boolean;
  public validation3: boolean;
  public userstatus3: boolean;
  public numberValidation: boolean;
  public numberValidationName: boolean;
  public userstatusNumbers: boolean;
  public userstatusNumbersName: boolean;
  public showPassword1 = false;
  public showPassword2 = false;

  constructor(
    private router: Router,
    private service: ArticlesService,
    public popoverCtrl: PopoverController,
    private storage: StorageProvider,
    private meta: MetaProvider,
    protected multitenant: Multitenant
  ) { }

  ionViewDidEnter() {
    this.meta.clearHead();
  }

  isLogin(): string {
    return 'login';
  }

  createAccount() {
    this.service.createAccountPost(this.model).subscribe(
      (response) => {
        this.login(response.email);
        this.router.navigate(['creer-compte','etape-2'], { queryParams: { first_name: response.first_name, last_name: response.last_name } });
      },
      (error) => {
        if (error[0]) {
          if (error[0].message && error[0].code === '300') {
            this.error.email = 'we have error';
          }
        }
      }
    );
  }

  login(username: string) {
    this.service
      .loginToPlatformGet(username, this.model.plainPassword)
      .subscribe(
        (response) => {
          this.storage.setStorage('noProfiles', 'true');
          this.storage.setStorage('access_token', response.access_token);
          this.storage.setStorage('refresh_token', response.refresh_token);
        },
        (error) => {
          this.error.message = ' Vos identifiants ne sont pas reconnus';
        }
      );
  }

  async presentPopover(myEvent) {
    const popover = this.popoverCtrl.create({
      component: InfoPopupComponent,
      componentProps: { page: 'step1' },
      cssClass: 'password-tooltip'
    });
    (await popover).present(myEvent);
  }

  checkOnBlur() {
    if (this.model.email === '') {
      this.userstatus = false;
    } else {
      this.userstatus = true;
    }
    // var patt = new RegExp("^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+\\@[a-zA-Z0-9-]+(\\.)?([a-zA-Z0-9-]{2,4})?\\.[a-zA-Z0-9-]{2,4}$");
    const patt = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    this.validation = patt.test(this.model.email);
  }

  checkOnBlur3() {
    let patt: RegExp;
    if (this.model.plainPassword === '') {
      this.userstatus3 = false;
    } else {
      this.userstatus3 = true;
    }

    if (this.multitenant.getDomainClass() !== 'mwjp') {
      patt = new RegExp(
        /^\S*(?=\S{12,})(?=\S*[a-z])(?=\S*[A-Z])(?=\S*[\d])\S*$/
      );
    } else {
      patt = new RegExp(
        /^\S*(?=\S{12,})(((?=\S*[a-z])(?=\S*[A-Z])(?=\S*[\d]))|(?=\S*[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]))\S*$/
      );
    }

    this.validation3 = patt.test(this.model.plainPassword);
  }

  checkOnBlur2() {
    if (this.model.plainPassword2 === '') {
      this.userstatus2 = false;
    } else {
      this.userstatus2 = true;
    }
    if (this.model.plainPassword !== this.model.plainPassword2) {
      this.validation2 = false;
    } else {
      this.validation2 = true;
    }
  }

  checkOnBlurNumbers() {
    const pattern = new RegExp(/^([^0-9]*)$/);
    this.numberValidation = pattern.test(this.model.firstName);
    if (this.model.firstName === '') {
      this.userstatusNumbers = false;
    } else {
      this.userstatusNumbers = true;
    }
  }

  checkOnBlurNumbersName() {
    const pattern = new RegExp(/^([^0-9]*)$/);
    this.numberValidationName = pattern.test(this.model.lastName);
    if (this.model.lastName === '') {
      this.userstatusNumbersName = false;
    } else {
      this.userstatusNumbersName = true;
    }
  }

  goToLogin() {
    this.router.navigate(['connexion']);
  }

  togglePassword(pswdNumber) {
    pswdNumber === 1
      ? (this.showPassword1 = !this.showPassword1)
      : (this.showPassword2 = !this.showPassword2);
  }
}
